import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInformation: {
    user_name: '',
    paternal_lastname: '',
    maternal_lastname: "",
    telephone_number: '',
    business_name: '',
  },
  extraInformation: {
    id_user: null,
    id_role: null,
    role: '',
    info_complete: null,
    privacy_policy: null,
    trust_business: null,
    is_warehouse: null,
    credits: null
  },
  permissions: [],
};

export const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserInformation(state, action ) {
      const { userInformation } = action.payload;
      state.userInformation = userInformation;
    },
    setPermissions(state, action) {
      const { permissions } = action.payload;
      state.permissions = permissions;
    },
    setExtraInformation(state, action ) {
      const { extraInformation } = action.payload;
      state.extraInformation = extraInformation;
    },
    resetInformation(state, action ) {
      state.extraInformation = {};
      state.userInformation = {};
    },
  },
});

export const { setUserInformation, setPermissions, setExtraInformation, resetInformation } = UserSlice.actions;

export default UserSlice.reducer;